export interface CodeOption {
  label: string
  value: string
  description: string
  occurrences: number
  hidden_from_search?: boolean
}

export function byCode(a: CodeOption, b: CodeOption) {
  // Natural sorting for alphanumeric strings with embedded numbers
  return a.value.localeCompare(b.value, undefined, {
    numeric: true,
    sensitivity: 'base',
  })
}
